import { ReactNode } from "react";
import { Setting, Symbols } from "./type";
import BigNumber from "bignumber.js";
import { GameCodes } from "../../type";

const SugarBlast2Utils = {
  isBuyingFreeSpin(bombCount: number): boolean {
    return bombCount >= 4;
  },
  cleanSymbolId(symbol: number): { symbolId: number; featureId: number } {
    const mod = symbol % 100;
    if (mod > 90) {
      const realSymbolId = +Math.floor(symbol / 100).toFixed(0);
      // 9X suffix, it is no regular symbol, need special handle
      if (mod === 91) {
        return { symbolId: realSymbolId, featureId: 1 };
      } else {
        return { symbolId: realSymbolId, featureId: +(mod - 90).toFixed(0) };
      }
    }
    if (symbol > 10 && symbol < 100) {
      return {
        symbolId: +Math.floor(symbol / 10).toFixed(0),
        featureId: +(symbol % 10).toFixed(0),
      };
    }
    return {
      symbolId: symbol,
      featureId: NaN,
    };
  },
  takeSymbol(reelMatrix: number[][], x: number, y: number): number {
    return reelMatrix[x][y];
  },
  convertSymbol(symbol: number, key?: string): ReactNode {
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case Symbols.StarCake:
        return <img key={key} alt="StarCake" src="/sb2/201.png" />;
      case Symbols.FlowerCookie:
        return <img key={key} alt="FlowerCookie" src="/sb2/202.png" />;
      case Symbols.HeartCandy:
        return <img key={key} alt="HeartCandy" src="/sb2/203.png" />;
      case Symbols.DiamondSwirlCandy:
        return <img key={key} alt="DiamondSwirlCandy" src="/sb2/204.png" />;
      case Symbols.PurpleDonutCandy:
        return <img key={key} alt="PurpleDonutCandy" src="/sb2/101.png" />;
      case Symbols.VioletLollipop:
        return <img key={key} alt="VioletLollipop" src="/sb2/102.png" />;
      case Symbols.BlueTearCandy:
        return <img key={key} alt="BlueTearCandy" src="/sb2/103.png" />;
      case Symbols.GreenJellybean:
        return <img key={key} alt="GreenJellybean" src="/sb2/104.png" />;
      case Symbols.GummyRocket:
        return <img key={key} alt="GummyRocket" src="/sb2/4.png" />;
      case Symbols.ChocolateBomb:
        return <img key={key} alt="ChocolateBomb" src="/sb2/3.png" />;
      case Symbols.MysterySweet:
        return <img key={key} alt="MysterySweet" src="/sb2/2.png" />;
      case Symbols.SugarBlast:
        return <img key={key} alt="SugarBlast" src="/sb2/8.png" />;
      case Symbols.IceBomb:
        return <img key={key} alt="IceBomb" src="/sb2/7.png" />;
      case Symbols.Bomb:
        return <img key={key} alt="Bomb" src="/sb2/5.png" />;
      case Symbols.BigBomb:
        return <img key={key} alt="BigBomb" src="/sb2/6.png" />;
      case 0:
        return <></>;
      default:
        return symbol;
    }
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount).multipliedBy(50); // buy free spin rate
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount)
      .multipliedBy(0.05) // bet size
      .multipliedBy(36) // 6*6 symbol count
      .multipliedBy(10) // sugar blast multiplier
      .multipliedBy(15); // max symbol payout
  },
} as const;

export default SugarBlast2Utils;
